import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from 'sweetalert2'
import exportValue from "../../apiconfig";
import Left_panel from '../Left_panel';
import Sub_header from '../Sub_header';
import '../../components/loader.css';
import { Navigate, useNavigate, useParams } from 'react-router-dom'
import { el } from "date-fns/locale";

const Post_delivery_pricing = () => {
    const { product_id, carrier_id } = useParams();
    console.log("product_id ==" , product_id)
    console.log("carrier_id ==" , carrier_id)

 
    const [state, setState] = useState(null);
    const [awbstate, setawbState] = useState(null);
  const [ visiblestate , setvisible] = React.useState(false)
  const [ tablestate , settable] = React.useState({amount:0 , gst:0 , total:0 , post_charges_name:"" , awb:"" , shipment:{}})

    
    const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);
    const [loading, setLoading] = useState(true);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
        const homeSection = document.querySelector('.home-section');
        if (homeSection) {
            homeSection.classList.toggle('sidebar-closed');
        }
    };
  
    const Toast = Swal.mixin({
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000
    });
   
   

    const getPrice = async () => {
        setLoading(true);
        
        try {
            const endpoint =  `${exportValue.host}/${exportValue.version}/${exportValue.api}/carrier_product_get_post_delivery_pricing`;
            
            const sendData = {
               product_id :product_id , carrier_id:carrier_id , charges:state , awb:awbstate
             };
            
            const response = await axios.post(endpoint, sendData, { headers: exportValue.headers })
            if(response.data.status==true){
                setvisible(true)
              settable({amount: response.data.amount, gst:response.data.gst , total:response.data.total , post_charges_name:response.data.post_charges_name , awb:response.data.awb , shipment:response.data.shipment})
            // Toast.fire({
            //     icon: 'success',
            //     title: response.data.message 
            // });
        }
        else{
            // setvisible(true)
            Toast.fire({
                icon: 'unsuccess',
                title: response.data.message 
            });
        }
        } catch (error) {
            console.error("Error saving product:", error);
            Toast.fire({
                icon: 'error',
                title: 'Failed to save product'
            });
        } finally {
            setLoading(false);
        }
    };


    const applyCharge = async () => {
        setLoading(true);
        
        try {
            if(tablestate.amount!=""){
            const endpoint =  `${exportValue.host}/${exportValue.version}/${exportValue.api}/apply_manual_post_delivery_pricing`;
            
            const sendData = {
               tablestate
             };
            console.log("sendData = =" , sendData)
            const response = await axios.post(endpoint, sendData, { headers: exportValue.headers })
            if(response.data.status==true){
                setvisible(true)
            //   settable({amount: response.data.amount, gst:response.data.gst , total:response.data.total , post_charges_name:response.data.post_charges_name , awb:response.data.awb})
            Toast.fire({
                icon: 'success',
                title: response.data.message 
            });
        }
        else{
            // setvisible(true)
            Toast.fire({
                icon: 'error',
                title: response.data.message 
            });
        }
    }else{
        Toast.fire({
            icon: 'error',
            title: 'Please fill amount'
        });
    }
        } catch (error) {
            console.error("Error saving product:", error);
            Toast.fire({
                icon: 'error',
                title: 'Failed to save product'
            });
        } finally {
            setLoading(false);
        }
    };

    const handleChange =(e)=>{
         let charge = (e.target.value *18)/100
 let total_amount = Number(e.target.value) +Number(charge)
 settable({...tablestate,amount:e.target.value,gst:charge , total:total_amount})
    }
//    React.useEffect(()=>{
//  let charge = (tablestate.amount *18)/100
//  let total_amount = Number(tablestate.amount+charge)
//  settable({gst:charge , total:total_amount})
//    },[tablestate.amount])
   
    return (
        <div>
            <Left_panel isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
            
            <section className="home-section">
                <Sub_header/>
            
                <div class="row mt-3 mb-3">
            <div class="col-12 col-md-2">
                <h5>VAS Charges</h5>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-12 col-md-6">
                <div class="card">
                <div class="card-body">
                    <div class="mb-3 mt-3">
                        <input type="text" class="form-control" id="email"  onChange={(e)=>setawbState(e.target.value)} placeholder="Enter AWB Number"/>
                    </div>
                    <div class="mb-3 mt-3">
                    <select className="form-select" onChange={(e)=>setState(e.target.value)}>
                                        <option>Select</option>
                                        <option value="appointment_charges">Appointment Charges</option>
                                        <option value="machinery_charges">Machinery Charges</option>
                                        <option value="manpower_charges">Manpower Charges</option>
                                        <option value="adhoc_vehicle_charges">Adhoc Vehicle Charges</option>
                                        <option value="mathadi_union_charges">Mathadi Union Charges</option>
                                        <option value="special_delivery_areas_charges">Special Delivery Areas Charges</option>
                                        <option value="re_attempt_charges">Re-Attempt Charges</option>
                                        <option value="csd_charges">CSD Charges</option>
                                        <option value="demurrage_charges">Demurrage Charges</option>
                                    </select>
                    </div>
                    <div class="mb-3 mt-3">
                        <div class="d-grid">
                        <a onClick={(e)=>getPrice(e)} class="btn btn-primary btn-block">Fetch Details</a>
                        </div>
                    </div>
                    <div class="mb-3 mt-3">
                        <div class="card bg-light border-0">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12 col-md-12">
                                    <small class="text-muted">Product</small>
                                    <h6>{tablestate.shipment.service_provider!=undefined?tablestate.shipment.service_provider:""}</h6>
                                </div>
                                <div class="col-12 col-md-4">
                                    <small class="text-muted">Height</small>
                                    <h6>{tablestate.shipment.height?tablestate.shipment.height:""}</h6>
                                </div>
                                <div class="col-12 col-md-4">
                                    <small class="text-muted">Width</small>
                                    <h6>{tablestate.shipment.width?tablestate.shipment.width:""}</h6>
                                </div>
                                <div class="col-12 col-md-4">
                                    <small class="text-muted">Length</small>
                                    <h6>{tablestate.shipment.length?tablestate.shipment.length:""}</h6>
                                </div>
                                <div class="col-12 col-md-4">
                                    <small class="text-muted">Weight</small>
                                    <h6>{tablestate.shipment.total_weight?tablestate.shipment.total_weight:""}</h6>
                                </div>
                                <div class="col-12 col-md-8">
                                    <small class="text-muted">Chargable Weight</small>
                                    <h6>{tablestate.shipment.total_weight?tablestate.shipment.total_weight:""}</h6>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div class="mb-3 mt-3">
                        <table class="table table-bordered mt-3">
                            <tbody>
                            <tr class="text-end">
                                <td class="w-50 ">Charges</td>
                                <td><input type="number" class="form-control form-control-lg" id="email" placeholder="" value={tablestate.amount} onChange={(e)=>handleChange(e)}/></td>
                            </tr>
                            <tr class="text-end">
                                <td class="w-50">GST (18%)</td>
                                <td>{tablestate.gst}</td>
                            </tr>
                            <tr class="fw-bold fs-5 text-end">
                                <td>Total</td>
                                <td>{tablestate.total}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                </div>

                <div class="d-grid mt-3">
            
                {visiblestate?     <a onClick={(e)=>applyCharge(e)} class="btn btn-primary btn-block">Apply Charges</a>:""}
                </div>
            </div>
            <div class="col-12 col-md-6">
                <section class="">
                    <div class="text-center mb-4">
                        <h2 class="fw-bold">How It Works</h2>
                        <p class="text-muted">Apply Value Added Services (VAS) to your B2B AWB numbers easily.</p>
                    </div>

                    <div class="row g-2">
                        <div class="col-12">
                        <div class="p-3 border rounded shadow-sm bg-light">
                            <h6 class="fw-semibold mb-1">1. Enter the AWB Number</h6>
                            <p class="mb-0 small">Start by entering the B2B AWB number for which you want to apply VAS charges.</p>
                        </div>
                        </div>

                        <div class="col-12">
                        <div class="p-3 border rounded shadow-sm bg-light">
                            <h6 class="fw-semibold mb-1">2. Select Applicable Charges</h6>
                            <p class="mb-0 small">Choose the specific VAS services such as packaging, insurance, or handling charges based on your shipment's requirements.</p>
                        </div>
                        </div>

                        <div class="col-12">
                        <div class="p-3 border rounded shadow-sm bg-light">
                            <h6 class="fw-semibold mb-1">3. Automatic Calculation</h6>
                            <p class="mb-0 small">Charges are auto-calculated based on the master VAS charges defined in the product selected during shipment creation.</p>
                        </div>
                        </div>

                        <div class="col-12">
                        <div class="p-3 border rounded shadow-sm bg-light">
                            <h6 class="fw-semibold mb-1">4. GST Charges</h6>
                            <p class="mb-0 small">The system automatically adds GST on top of the VAS charges and displays a clear breakdown on the same page.</p>
                        </div>
                        </div>

                        <div class="col-12">
                        <div class="p-3 border rounded shadow-sm bg-light">
                            <h6 class="fw-semibold mb-1">5. Apply to Wallet</h6>
                            <p class="mb-0 small">Once confirmed, the charges (including GST) will be deducted from your wallet and linked to the AWB number.</p>
                        </div>
                        </div>

                        <div class="col-12">
                        <div class="p-3 border rounded shadow-sm bg-light">
                            <h6 class="fw-semibold mb-1">6. Edit Charges (Optional)</h6>
                            <p class="mb-0 small">Need to make changes? You can edit the VAS charges before finalizing and applying them.</p>
                        </div>
                        </div>
                    </div>

                    <div class="alert alert-info mt-2" role="alert">
                        <strong>Tip:</strong> Keep your product VAS charge settings up to date for accurate calculations.
                    </div>
                </section>
            </div>
        </div>
               

{/* <div class="container mt-3">
  <div class="row justify-content-center">
      <div class="col-12 col-md-8">
        <div class="card">
          <div class="card-body">
            <div class="mb-3 mt-3">
                <input type="text" class="form-control" id="email"  onChange={(e)=>setawbState(e.target.value)} placeholder="Enter AWB Number"/>
            </div>
            <div class="mb-3 mt-3">
            <select className="form-control" onChange={(e)=>setState(e.target.value)}>
                                        <option>Select</option>
                                        <option value="appointment_charges">Appointment Charges</option>
                                        <option value="machinery_charges">Machinery Charges</option>
                                        <option value="manpower_charges">Manpower Charges</option>
                                        <option value="adhoc_vehicle_charges">Adhoc Vehicle Charges</option>
                                        <option value="mathadi_union_charges">Mathadi Union Charges</option>
                                        <option value="special_delivery_areas_charges">Special Delivery Areas Charges</option>
                                        <option value="re_attempt_charges">Re-Attempt Charges</option>
                                        <option value="csd_charges">CSD Charges</option>
                                        <option value="demurrage_charges">Demurrage Charges</option>
                                    </select>
            </div>
            <div class="mb-3 mt-3">
                <div class="d-grid">
                  <a onClick={(e)=>getPrice(e)} class="btn btn-primary btn-block">Fetch Details</a>
                </div>
            </div>
            <div class="mb-3 mt-3">
                <div class="card bg-light border-0">
                  <div class="card-body">
                    <div class="row">
                        <div class="col-12 col-md-12">
                            <small class="text-muted">Product</small>
                            <h6>{tablestate.shipment.service_provider!=undefined?tablestate.shipment.service_provider:""}</h6>
                        </div>
                        <div class="col-12 col-md-4">
                            <small class="text-muted">Height</small>
                            <h6>{tablestate.shipment.height?tablestate.shipment.height:""}</h6>
                        </div>
                        <div class="col-12 col-md-4">
                            <small class="text-muted">Width</small>
                            <h6>{tablestate.shipment.width?tablestate.shipment.width:""}</h6>
                        </div>
                        <div class="col-12 col-md-4">
                            <small class="text-muted">Length</small>
                            <h6>{tablestate.shipment.length?tablestate.shipment.length:""}</h6>
                        </div>
                        <div class="col-12 col-md-4">
                            <small class="text-muted">Weight</small>
                            <h6>{tablestate.shipment.total_weight?tablestate.shipment.total_weight:""}</h6>
                        </div>
                        <div class="col-12 col-md-8">
                            <small class="text-muted">Chargable Weight</small>
                            <h6>{tablestate.shipment.total_weight?tablestate.shipment.total_weight:""}</h6>
                        </div>
                    </div>
                  </div>
                </div>
            </div>
            <div class="mb-3 mt-3">
                <table class="table table-bordered mt-3">
                    <tbody>
                      <tr class="text-end">
                        <td class="w-50 ">Charges</td>
                        <td><input type="text" class="form-control form-control-lg" id="email" placeholder="" value={tablestate.amount} onChange={(e)=>handleChange(e)}/></td>
                      </tr>
                      <tr class="text-end">
                        <td class="w-50">GST (18%)</td>
                        <td>{tablestate.gst}</td>
                      </tr>
                      <tr class="fw-bold fs-5 text-end">
                        <td>Total</td>
                        <td>{tablestate.total}</td>
                      </tr>
                    </tbody>
                </table>
            </div>
          </div>
        </div>

        <div class="d-grid mt-3 mb-5">
     {visiblestate?     <a onClick={(e)=>applyCharge(e)} class="btn btn-primary btn-block">Apply Charges</a>:""}
        </div>
      </div>
  </div>
</div> */}

               <section>
                </section> 
            </section>
        </div>
    );
};

export default Post_delivery_pricing;